module.exports = __webpack_public_path__ + "static/media/linkedin.6153d12a.svg";